import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as mapActions from '../actions/map-actions';
import StateMap from "../charts/StateMap";

import ScatterPlot from '../charts/ScatterPlot';
import ReadMore from '../components/ReadMore';
import CardMenu from './CardMenu';

import './StateCard.css';
import NationalSelector from "../charts/NationalSelector/index";

class StateCard extends Component {
  render() {
    const selectState = this.props.actions.selectState;
    const selectCounty = this.props.actions.selectCounty;

    const title = (
      <CardMenu showLocations={true} showDimensions={true}
                title={this.props.selectedState.name + ' State Opioid Statistics'}/>
    );

    return (
      <Card className="StateCard" title={title} noHovering={true} loading={this.props.loading}>
        <Row gutter={34} type="flex">
          <Col xs={24} md={{span: 6, order: 1}} xl={{span: 5, order: 1}}>

            <p>At the state and county level, it is easier to see the local impact of opioids, and better
              understand how this critical issue impacts communities.</p>

            <p className="lead">
              This visualization allows you to drill in and see the two data dimensions at the county level
              for a selected state.
            </p>

            <ReadMore>
              <p>The main map enables you to see the two dimensions plotted against each other at a county level.
                More red indicates the county had higher {this.props.xLabel} while more blue indicates the county had
                higher {this.props.yLabel}. If the county was high in both, it will appear medium to dark purple.
                The distribution of counties across both dimensions is visualized in the scatterplot on the bottom right
                and also acts as a legend for the map coloring.</p>

              <p>Additionally the two smaller maps reference each dimension separately so one can analyze one variable
                at a time. The dimensions or the selected state can be changed using the menu
                dropdown <i>(upper left)</i>, or the state can be changed using the small US map to the right.</p>

              <p><b>Source Data:</b><br/>
                <a
                  href="https://www.cms.gov/Research-Statistics-Data-and-Systems/Statistics-Trends-and-Reports/Medicare-Provider-Charge-Data/PartD2014.html"
                  target="_blank" rel="noopener noreferrer">
                  CMS - Medicare Part D Prescriber Data 2014
                </a>
              </p>
            </ReadMore>
          </Col>
          <Col xs={24} md={{span: 13, order: 3}} xl={{span: 14, order: 3}}>
            <div className="main-state-map">
              <h2>{this.props.xLabel}<br/>vs. {this.props.yLabel}</h2>
              <StateMap
                stateFips={this.props.selectedState.fips}
                titleX={this.props.xLabel}
                titleY={this.props.yLabel}
                dimX={this.props.xField}
                dimY={this.props.yField}
                dict={this.props.dict}
                data={this.props.data}
                onClick={(stateId, countyId) => selectCounty(countyId)}
                showCities={true}/>
            </div>
          </Col>
          <Col xs={24} md={{span: 5, order: 2}} xl={{span: 5, order: 2}}>
            <Row gutter={35}>
              <Col xs={12} md={24}>
                <h2>{this.props.xLabel}</h2>
                <StateMap
                  stateFips={this.props.selectedState.fips}
                  titleX={this.props.xLabel}
                  titleY={this.props.yLabel}
                  dimX={this.props.xField}
                  dict={this.props.dict}
                  data={this.props.data}
                  onClick={(stateId, countyId) => selectCounty(countyId)}/>
              </Col>
              <Col xs={12} md={24}>
                <h2>{this.props.yLabel}</h2>
                <StateMap
                  stateFips={this.props.selectedState.fips}
                  titleX={this.props.xLabel}
                  titleY={this.props.yLabel}
                  dimY={this.props.yField}
                  dict={this.props.dict}
                  data={this.props.data}
                  onClick={(stateId, countyId) => selectCounty(countyId)}/>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="map-selector-wrapper">
          <NationalSelector
            selectedState={this.props.selectedState.fips}
            onClick={stateId => selectState(stateId)}/>
        </div>
        <div className="scatter-wrapper">
          <ScatterPlot
            dimId={this.props.idField}
            dimX={this.props.xField}
            dimY={this.props.yField}
            titleX={this.props.xLabel}
            titleY={this.props.yLabel}
            data={this.props.data}/>
        </div>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.counties.loading,
    data: store.counties.data,
    dict: store.counties.dict,
    idField: store.dimensions.countyKey,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    selectedState: store.states.selected
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(mapActions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateCard);



// WEBPACK FOOTER //
// ./src/containers/StateCard.js